import { createContext } from 'react';
import { Protocol } from '../../../api/protocolsApi/ProtocolsApi';

interface ProtocolContextProps {
  protocol: Protocol | null;
  loading: boolean;
  error: string | null;
  setLoading: (loading: boolean) => void;
  refetch: () => void;
  setProtocol: React.Dispatch<React.SetStateAction<Protocol | null>>;
}

export const ProtocolContext = createContext<ProtocolContextProps | null>(null);
